import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../assets/images/logo.png";
import { allowedToView } from "../utils/PermissionUtils";

function Sidebar() {
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const sidebarRef = useRef(null);
    const toggleButtonRef = useRef(null);
    const location = useLocation();
    const userRole = localStorage.getItem("userRole");

    const isAdmin = allowedToView(userRole, ['admin']);
    const isSuperAdmin = allowedToView(userRole, ['superadmin']);
    const isUser = allowedToView(userRole, ['user']);
    const isAggregator = allowedToView(userRole, ['aggregator']);
    // Toggle sidebar
    const toggleSidebar = () => {
        setSidebarOpen(!isSidebarOpen);
    };

    // Close sidebar when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                sidebarRef.current &&
                !sidebarRef.current.contains(event.target) &&
                toggleButtonRef.current &&
                !toggleButtonRef.current.contains(event.target)
            ) {
                setSidebarOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Close sidebar on navigation
    useEffect(() => {
        setSidebarOpen(false);
    }, [location]);

    return (
        <>
            <button
                ref={toggleButtonRef}
                className="button is-light toggle-sidebar-btn primary-bg"
                onClick={toggleSidebar}
                aria-label="Toggle Sidebar"
            >
                {isSidebarOpen ? "✕" : "☰"}
            </button>
            <aside
                ref={sidebarRef}
                className={`menu pb-6 sidebar ${isSidebarOpen ? "is-active" : ""}`}
            >
                <div className="sidebar-logo-section">
                    <Link to="/" className="logo-link">
                        <img src={Logo} alt="CFCM" className="sidebar-logo" />
                    </Link>
                </div>
                <div className="sidebar-menu">
                    <ul className="menu-list">
                        {(isAdmin || isSuperAdmin || isUser) && (
                            <>                        <li>
                                <Link to="/dashboard">Dashboard</Link>
                            </li>
                                <li>
                                    <Link to="/dashboard/users">Users</Link>
                                </li>
                                <li>
                                    <Link to="/dashboard/farmers">Farmers</Link>
                                </li>
                                <li>
                                    <Link to="/dashboard/milk-collections">Milk Collection</Link>
                                </li>
                                <li>
                                    <Link to="/dashboard/payment-periods">Milk Payments</Link>
                                </li>
                                <li>
                                    <Link to="/dashboard/products">Products</Link>
                                </li>
                                <li>
                                    <Link to="/dashboard/debts">Debts</Link>
                                </li>
                                 <li>
                                    <Link to="/dashboard/debt-repayments">Debt Repayments</Link>
                                </li>
                                <li>
                                    <Link to="/dashboard/milk-prices">Milk Price</Link>
                                </li>
                                <li>
                                    <Link to="/dashboard/collection-routes">Routes</Link>
                                </li>
                            </>
                        )}

                        {(isAggregator || isSuperAdmin) && (
                            <>
                                <li>
                                    <Link to="/dashboard/aggregations">Aggregations</Link>
                                    <Link to="/dashboard/milk-sales">Milk Sales</Link>
                                </li>
                               
                            </>
                        )}

                        {(isAdmin || isSuperAdmin) && (
                            <>
                                <li>
                                    <Link to="/dashboard/expenses">Expenses</Link>
                                </li>
                               
                            </>
                        )}


                    </ul>

                    <hr />
                    <ul className="menu-list">
                        <li>
                            <Link to="/dashboard/profile">Profile</Link>
                        </li>
                        <li>
                            <Link to="/dashboard/profile/reset-password">Reset Password</Link>
                        </li>
                        <li>
                            <Link to="/logout">Log Out</Link>
                        </li>
                    </ul>
                </div>
            </aside>
        </>
    );
}

export default Sidebar;
